<template>
  <div>
    <v-dialog
      v-model="editDialog.show"
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">
          <span v-text="editDialog.forCreate ? '新增診所' : '編輯診所'"></span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="editDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="editForm">
            <v-text-field
              v-model="editDialog.clinic"
              :rules="editDialog.clinicRules"
              :disabled="!editDialog.forCreate"
              label="診所識別號"
              required
            ></v-text-field>
            <v-text-field
              v-model="editDialog.name"
              :rules="editDialog.nameRules"
              label="診所名稱"
              required
            ></v-text-field>
            <v-text-field
              v-model="editDialog.adminName"
              :rules="editDialog.adminNameRules"
              label="管理員名稱"
              required
            ></v-text-field>
            <v-text-field
              v-model="editDialog.adminPhone"
              :rules="editDialog.adminPhoneRules"
              label="管理員手機"
              :disabled="!editDialog.forCreate"
              required
            ></v-text-field>
            <v-text-field
              v-model="editDialog.password"
              :rules="editDialog.passwordRules"
              :class="{ overline: !editDialog.forCreate }"
              label="密碼"
              required
              :append-icon="editDialog.forCreate ? '' : 'mdi-shield-edit'"
              @click:append="showResetPassword"
              :readonly="!editDialog.forCreate"
            ></v-text-field>
            <v-text-field
              v-model="editDialog.botId"
              label="Line BotId"
              required
            ></v-text-field>
            <v-text-field
              v-model="editDialog.liff_QRcode"
              label="Line QRCode LiffId"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="editDialog.show = false">取消</v-btn>
          <v-btn
            color="success"
            text
            :loading="editDialog.loading"
            @click="editDialog.forCreate ? createClinic() : updateClinic()"
            v-text="editDialog.forCreate ? '新增' : '儲存'"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="resetPasswrodDialog.show"
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">
          <span v-text="`重置${resetPasswrodDialog.admin}密碼`"></span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="resetPasswrodDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="resetForm">
            <v-text-field
              v-model="resetPasswrodDialog.password"
              :rules="resetPasswrodDialog.passwordRules"
              label="新密碼"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="resetPasswrodDialog.show = false"
            >取消</v-btn
          >
          <v-btn color="success" text @click="resetPassword">更新</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["clinicNames"],
  data: thisVm => ({
    editDialog: {
      loading: false,
      show: false,
      forCreate: false,
      clinic: "",
      clinicRules: [
        v => !!v || "請輸入診所名稱",
        v =>
          (v && /^[0-9A-Za-z_]+$/.test(v)) ||
          "診所名稱僅可包含數字、大小寫英文與'_'",
        v => thisVm.clinicNames.indexOf(v) === -1 || "診所名稱已被使用"
      ],
      name: "",
      nameRules: [v => !!v || "請輸入診所名稱"],
      adminName: "",
      adminNameRules: [v => !!v || "請輸入管理員名稱"],
      adminPhone: "",
      adminPhoneRules: [
        v => !!v || "請輸入管理員手機",
        v => (v && v.length >= 10) || "錯誤的手機門號"
      ],
      password: "",
      passwordRules: [
        v => !!v || "請輸入密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元"
      ]
    },
    resetPasswrodDialog: {
      show: false,
      admin: "",
      password: "",
      passwordRules: [
        v => !!v || "請輸入新密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元"
      ]
    }
  }),
  methods: {
    async showCreateClinic() {
      if (this.$refs.editForm) {
        this.$refs.editForm.reset();
        await this.$nextTick();
      }
      this.editDialog.forCreate = true;
      this.editDialog.show = true;
    },
    async showUpdateClinic(clinic) {
      console.log("clinic:" + JSON.stringify(clinic));
      if (this.$refs.editForm) {
        this.$refs.editForm.reset();
        await this.$nextTick();
      }
      this.editDialog.clinic = clinic.clinic;
      this.editDialog.name = clinic.name;
      this.editDialog.adminName = clinic.admin.name;
      this.editDialog.adminPhone = clinic.admin.phone;
      this.editDialog.botId = clinic.botId;
      this.editDialog.liff_QRcode = clinic.liff_QRcode;

      this.editDialog.password = "●●●●●●●";
      this.editDialog.forCreate = false;
      this.editDialog.show = true;
    },
    async createClinic() {
      console.log("createClinic");
      if (this.$refs.editForm.validate()) {
        console.log("validate");
        this.editDialog.loading = true;

        let response = await this.$ajax.post(
          `${this.$config.apiUrl}/clinicData`,
          {
            clinic: this.editDialog.clinic,
            name: this.editDialog.name,
            botId: this.editDialog.botId,
            liff_QRcode: this.editDialog.liff_QRcode
          }
        );
        console.log("response:" + JSON.stringify(response.data));

        response = await this.$ajax.post(`${this.$config.apiUrl}/adminCreate`, {
          name: this.editDialog.adminName,
          phone: this.editDialog.adminPhone,
          password: this.editDialog.password,
          permission: "role_admin",
          clinic: this.editDialog.clinic
        });
        console.log("response:" + JSON.stringify(response.data));

        this.editDialog.show = false;
        this.editDialog.loading = false;
        this.$emit("created");
      }
    },
    async updateClinic() {
      if (this.$refs.editForm.validate()) {
        this.editDialog.loading = true;
        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.editDialog.clinic}/users/${this.editDialog.adminPhone}`,
          { name: this.editDialog.adminName }
        );

        await this.$ajax.put(
          `${this.$config.apiUrl}/clinicData/${this.editDialog.clinic}`,
          {
            name: this.editDialog.name,
            botId: this.editDialog.botId,
            liff_QRcode: this.editDialog.liff_QRcode
          }
        );

        this.editDialog.loading = false;
        this.editDialog.show = false;
        this.$emit("updated");
      }
    },
    async showResetPassword() {
      if (this.$refs.resetForm) {
        this.$refs.resetForm.reset();
        await this.$nextTick();
      }
      this.resetPasswrodDialog.show = true;
    },
    async resetPassword() {
      if (this.$refs.resetForm.validate()) {
        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.editDialog.clinic}/staff/${this.editDialog.adminPhone}/reset`,
          { newPwd: this.resetPasswrodDialog.password }
        );
        this.resetPasswrodDialog.show = false;
      }
    }
  }
};
</script>

<style></style>
